export enum AppRoutes {
  MAIN_PAGE = 'applications',
  EXCEPTION_MESSAGES = 'exception-messages',
}
